export const CnpTypes: { [key: number]: string } = {
    1: "General",
    2: "EEG",
    3: "EMG",
};